var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{staticClass:"mt-2",attrs:{"label":_vm.$t('dangerousGoods.dangerousGoodsList.form.safetyDataSheet'),"accept":"application/pdf","outlined":"","value":_vm.defaultValueInput},on:{"change":_vm.handleFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }